<div class="modal-header">
  <h4 class="modal-title pull-left">
    <app-icon icon="home" iconClass="button-icon"></app-icon> Add Vehicle Rates
  </h4>
</div>
@if (!addedRates) {
  <div class="modal-body">
    <app-vehicle-rates [hospital]="hospital" (vehicleRatesUpdated)="vehicleRatesUpdate($event)" (modalClosed)="modalClosed()"></app-vehicle-rates>
  </div>
}
